import { staleWhileRevalidateConfig } from '@/core/helpers/http.helper';
import { LocationQuery } from 'vue-router';
import { http } from '../../helpers/http.helper';
import { ApiResource } from './../../models/api-resource.interface';
import { FilterInfo, FilterInfoType } from './filter-info.interface';

export class FilterInfoService {
   async getFilterInfo(filterInfoType: FilterInfoType, query?: LocationQuery) {
      const config = staleWhileRevalidateConfig;

      const response = await http.get<ApiResource<FilterInfo>>(
         `/filter-info/${filterInfoType}`,
         !query ? { ...config } : { params: query },
      );
      return response.data?.data;
   }
}
